
import {
  ForgotPasswordCommand,
  ConfirmForgotPasswordCommand,
  RespondToAuthChallengeCommand
} from "@aws-sdk/client-cognito-identity-provider";

import { cognitoClient } from "./cognito-client";


export async function initiateForgotPassword(username) {
  try {
    const command = new ForgotPasswordCommand({
      ClientId: process.env.REACT_APP_CLIENT_ID,
      Username: username
    });
    const response = await cognitoClient.send(command);
    console.log("Forgot Password initiated:", response);
    return response;
  } catch (error) {
    console.error("Error initiating forgot password:", error);
    throw error;
  }
}


export async function confirmForgotPassword(username, code, newPassword) {
  console.log("Here the otp",username,code,newPassword)
  try {
    const command = new ConfirmForgotPasswordCommand({
      ClientId: process.env.REACT_APP_CLIENT_ID,
      Username: username,
      ConfirmationCode: code,
      Password: newPassword
    });
    const response = await cognitoClient.send(command);
    console.log("Password reset confirmed:", response);
    return response;
  } catch (error) {
    console.error("Error confirming forgot password:", error);
    throw error;
  }

}


export async function setNewPassword(username, newPassword) {
  try {
    const sessionToken = sessionStorage.getItem('SessionToken');

    if (!sessionToken) {
      return { success: false, message: "Session token missing. Please restart the login process." };
    }
    const command = new RespondToAuthChallengeCommand({
      ClientId: process.env.REACT_APP_CLIENT_ID,
      ChallengeName: "NEW_PASSWORD_REQUIRED",
      Session: sessionToken,
      ChallengeResponses: {
        USERNAME: username,
        NEW_PASSWORD: newPassword
      }
    });

    const response = await cognitoClient.send(command);
    return { success: true, data: response };

  } catch (error) {
    console.error("Error resetting password:", error);
    return {
      success: false,
      message: error.message || "Failed to reset password. Please try again."
    };
  }
}
